import React from 'react';
import PropTypes from 'prop-types';

import css from './Image.module.scss';

class Image extends React.Component {

    static propTypes = {
        active: PropTypes.bool.isRequired,
        image: PropTypes.shape({
            image: PropTypes.string.isRequired,
            altText: PropTypes.string.isRequired
        }),
        onLoad: PropTypes.func,
    }

    render(){
        const {
            active,
            image,
            onLoad,
        } = this.props;

        return (
            <div className={css.image}>
                <img
                    alt={image.altText ? image.altText : ''}
                    data-active={active}
                    onLoad={onLoad}
                    src={image.image}
                />
            </div>
        );
    }

}

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/Image.jsx